import "./navbar.css";
import Logo from "../../images/VIBE-Logo-New.png";
import { Link } from "react-router-dom";
// import { numBikeflagfalse } from "../../Redux/actions/NumBikeation";
// import { useDispatch } from "react-redux";
// import { useHistory } from "react-router-dom";
export const NavbarJourney = () => {
  // const dispatch = useDispatch()
  // const history = useHistory()
  // const home = ()=> {
  //   dispatch(numBikeflagfalse(''))
  //   history.push('/')
  // }
  return (
    <header
      className="bg-white w-100 d-block border-bottom"
      style={{ padding: "5px 0px" }}
    >
      <div className="container d-flex justify-content-between align-items-center">
        <Link to="/" className="text-decoration-none">
          <img
            src={Logo}
            className="navbar-brand mt-0 position-relative"
            style={{ maxWidth: "125px" }}
            alt=""
          />
        </Link>
        <Link to="/" className="text-decoration-none">
          <p className="mb-0">Home</p>
        </Link>
      </div>
    </header>
  );
};
